import React from 'react';
import ToastMessage, { toastify } from '../../components/shared/Toasts';
import { ClearanceLoading, ClearanceForm, ClearanceFail, ClearanceMatch } from './';

const toastErrorMessage = (
    <ToastMessage icon="exclamation">
        Something Appears to be Wrong. <br />
        Contact us through the mail icon on the bottom of the screen for assistance
    </ToastMessage>
);

export default class Clearance extends React.Component {
    componentWillMount() {
        const { prepareSubmissionStatus, checkNecessaryProps, person, fetchBrokers } = this.props;
        if (person.isUnderwriter) {
            fetchBrokers();
        }
        if (!checkNecessaryProps(this.props)) {
            return null;
        }

        prepareSubmissionStatus();
    }

    componentWillUpdate(nextProps, nextState) {
        const {
            clearance,
            submission,
            checkNecessaryProps,
            isMatchedFound,
            onPass,
            onPending,
            onFail,
            onMatch,
            onError
        } = nextProps;

        if (!checkNecessaryProps(nextProps)) {
            return false;
        }

        if (!clearance.data) {
            return true;
        }

        if (isMatchedFound(clearance)) {
            onMatch(submission, clearance);
            return true;
        }

        // Analyse clerance status
        switch (clearance.data.status) {
            case 'pass':
                onPass(submission, clearance);
                break;
            case 'pending':
                onPending(submission, clearance);
                break;
            case 'fail':
                onFail(submission, clearance);
                break;
            default:
                toastify.error(toastErrorMessage);
                onError('Unhandled clearance status', false);
        }

        return true;
    }

    handleResetClearance = () =>{
        this.props.cleanup();
    }
    
    componentWillUnmount() {
        this.props.cleanup();
    }

    render() {
        console.warn('New Clearance rendered'); // @todo to insure this version was rendered, remove after implementation of Present Submissions from same Agency to Broker
        const {
            clearance,
            submission,
            user,
            isMatchedFound,
            onFormSubmit,
            checkNecessaryProps,
            resetClearance,
            onError,
            resolveMatched,
            ignoreMatched,
            person,
            onUpdateBrokerId,
            brokers,
            underwriterName
        } = this.props;

        if (!checkNecessaryProps(this.props, false)) {
            return null;
        }

        if (clearance.isBusy) {
            return <ClearanceLoading />;
        }

        if (clearance.error) {
            // API responded with error
            toastify.error(toastErrorMessage);
            onError(clearance.error, false);
        }

        if (!clearance.data || !clearance.data.status) {
            // No data yet, form is clean
            const values= clearance.error? '' : clearance.formData;
            return (
                <ClearanceForm
                    onSubmit={input => {
                        return onFormSubmit(input, submission.type, user, person);
                    }}
                    onUpdateBrokerId={brokerId => {
                        return onUpdateBrokerId(brokerId, submission.type, person);
                    }}
                    values= {values}
                    person={person}
                    brokers={brokers}
                    user={user}
                    underwriterName={underwriterName}
                />
            );
        }

        if (isMatchedFound(clearance)) {
            // Found matches
            return (
                <ClearanceMatch
                    submission={submission}
                    clearance={clearance}
                    resolveMatched={match => resolveMatched(match, user)}
                    ignoreMatched={ignoreMatched}
                    resetClearance={this.handleResetClearance}
                    person={person}
                    selectedAgency={brokers.find(({ brokerId }) => brokerId === person.brokerId)}
                />
            );
        }

        if (clearance.data.status === 'fail') {
            // Clearance is failed
            return <ClearanceFail formData={clearance.formData} resetClearance={this.handleResetClearance} />;
        }

        return null;
    }
}
